import { put, takeLatest } from "redux-saga/effects";
import { requestLatePaymentFeeDetailsList,requestCreateGenerateInvoice } from "services/acclgl/reports/latePaymentFeeDetails";
import {
  fetchLatePaymentFeeDetailsListRequest,
  fetchLatePaymentFeeDetailsListSuccess,
  fetchLatePaymentFeeDetailsListFailure,
  createGenerateInvoiceRequest,
  createGenerateInvoiceSuccess,
  createGenerateInvoiceFaliure,
} from "redux/reducers/acclgl/reports/latePaymentFeeDetails";

export function* watchLatePaymentFeeDetailsSaga() {
  yield takeLatest(
    fetchLatePaymentFeeDetailsListRequest,
    fetchlatePaymentFeeDetailsList
  );
  yield takeLatest(createGenerateInvoiceRequest, createGenerateInvoiceService);
}

function* fetchlatePaymentFeeDetailsList({ payload }) {
    try {
      const response = yield requestLatePaymentFeeDetailsList(payload);
      yield put(fetchLatePaymentFeeDetailsListSuccess(response));
    } catch (error) {
      yield put(
        fetchLatePaymentFeeDetailsListFailure("Failed to get list of reports")
      );
    }
  }

  function* createGenerateInvoiceService({ payload }) {
    try {
      const response = yield requestCreateGenerateInvoice(payload);
      console.log(response, "sagaresponse");
      yield put(createGenerateInvoiceSuccess(response.data));
    } catch (error) {
      yield put(createGenerateInvoiceFaliure("Incorrect Invoice"));
    }
  }